import { generateCustomerId } from '@/utils/formatters'

// Mock Customers Data
export const mockCustomers = [
  {
    id: '1',
    customerId: generateCustomerId(),
    name: 'John Doe',
    phone: '+1234567890',
    orderCount: 25,
    totalSpend: 3450.0,
    status: 'ACTIVE',
    createdAt: '2024-01-10T10:00:00Z',
  },
  {
    id: '2',
    customerId: generateCustomerId(),
    name: 'Jane Smith',
    phone: '+1234567890',
    orderCount: 5,
    totalSpend: 250.0,
    status: 'INACTIVE',
    createdAt: '2024-02-14T12:00:00Z',
  },
  {
    id: '3',
    customerId: generateCustomerId(),
    name: 'Emily Davis',
    phone: '+1234567890',
    orderCount: 30,
    totalSpend: 4600.0,
    status: 'VIP',
    createdAt: '2024-03-01T09:30:00Z',
  },
  {
    id: '4',
    customerId: generateCustomerId(),
    name: 'Michael Brown',
    phone: '+1234567890',
    orderCount: 12,
    totalSpend: 1200.0,
    status: 'ACTIVE',
    createdAt: '2024-01-20T08:15:00Z',
  },
  {
    id: '5',
    customerId: generateCustomerId(),
    name: 'Olivia Wilson',
    phone: '+1234567890',
    orderCount: 3,
    totalSpend: 180.0,
    status: 'INACTIVE',
    createdAt: '2024-02-28T11:00:00Z',
  },
]

// API helpers
export async function getCustomers({ page = 1, size = 10, search = '', status = '' } = {}) {
  await new Promise((resolve) => setTimeout(resolve, 300))
  let filtered = [...mockCustomers]

  if (search) {
    const s = search.toLowerCase()
    filtered = filtered.filter(c =>
      c.customerId.toLowerCase().includes(s) ||
      c.name.toLowerCase().includes(s) ||
      c.phone.toLowerCase().includes(s)
    )
  }

  if (status) {
    filtered = filtered.filter(c => c.status === status)
  }

  const start = (page - 1) * size
  const end = start + size

  return {
    data: filtered.slice(start, end),
    meta: {
      page,
      size,
      total: filtered.length,
      totalPages: Math.ceil(filtered.length / size),
    },
  }
}

export async function updateCustomerStatus(id, status) {
  await new Promise((resolve) => setTimeout(resolve, 200))
  const index = mockCustomers.findIndex(c => c.id === id)
  if (index === -1) throw new Error('Customer not found')
  mockCustomers[index] = { ...mockCustomers[index], status }
  return mockCustomers[index]
}

export async function getCustomer(id) {
  await new Promise((resolve) => setTimeout(resolve, 200))
  const customer = mockCustomers.find(c => c.id === id)
  if (!customer) throw new Error('Customer not found')
  return customer
}
